module.exports = __webpack_public_path__ + "static/media/clock.8a3e3b71.svg";